import Vuex from "vuex";
import Vue from "vue";

//import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    logged: false,
    firebaseAccessToken: "",
    firebaseUser: {},
    redirectPath: "",
    detailName: "",
    detailSurname: "",
    detailPrimaryMail: "",
    detailPhone: "",
    detailSecondaryMail: "",
    isToHumanitas: false,
    userFlux: "",
    communicationID: null,
    patientID: "",
    prefix: "+39",
    locationID: null
  },
  mutations: {
    prefix(state, prefix) {
      state.prefix = prefix;
    },
    replyPatientID(state, patientID) {
      state.patientID = patientID;
    },
    replyCommunicationID(state, communicationID) {
      state.communicationID = communicationID;
    },
    replyLocationID(state, locationID) {
      state.locationID = locationID;
    },
    userFlux(state, path) {
      state.userFlux = path;
    },
    userLoggedIn(state) {
      state.logged = true;
    },
    userLoggedOut(state) {
      state.logged = false;
    },
    firebaseTokenUpdated(state, accessToken) {
      state.firebaseAccessToken = accessToken;
    },
    firebaseUserUpdated(state, user) {
      state.firebaseUser = user;
    },
    firebaseUserTokenUpdated(state, accessToken) {
      state.firebaseUser.stsTokenManager.accessToken = accessToken;
    },
    setRedirectPath(state, path) {
      state.redirectPath = path;
    },
    userName(state, name) {
      state.detailName = name;
    },
    userSurname(state, surname) {
      state.detailSurname = surname;
    },
    userPrimaryMail(state, primaryMail) {
      state.detailPrimaryMail = primaryMail;
    },
    userSecondaryMail(state, secondaryMail) {
      state.detailSecondaryMail = secondaryMail;
    },
    userPhone(state, phone) {
      state.detailPhone = phone;
    },
    userBirthDate(state, birthdate) {
      state.detailBirthDate = birthdate;
    },
    clinicToPatients(state) {
      state.isToHumanitas = false;
    },
    patientsToClinic(state) {
      state.isToHumanitas = true;
    }
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/plugins/vuex/index.js